// src/components/ScrollToTopButton.js
import "../../styles/Components.css";

function ScrollToTopButton({ show }) {
  const smoothScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!show) return null;

  return (
    <button
      onClick={smoothScrollToTop}
      className="scroll-to-top-button"
    >
      ↑
    </button>
  );
}

export default ScrollToTopButton;